import { render, staticRenderFns } from "./MessagesNew.vue?vue&type=template&id=26d90788&scoped=true&"
import script from "./MessagesNew.vue?vue&type=script&lang=js&"
export * from "./MessagesNew.vue?vue&type=script&lang=js&"
import style0 from "./MessagesNew.vue?vue&type=style&index=0&id=26d90788&prod&lang=scss&scoped=true&"
import style1 from "./MessagesNew.vue?vue&type=style&index=1&id=26d90788&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d90788",
  null
  
)

export default component.exports